// src/components/ui/TransferenciaModal.jsx
import React, { useState, useEffect } from "react";
import transacoesService from "../../services/transacoesService";
import contasBancariasService from "../../services/contasBancariasService";

const fmtM = v => Number(v||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});

export default function TransferenciaModal({ idCondominio, onClose, onSucesso }) {
  const [contas,   setContas]   = useState([]);
  const [saving,   setSaving]   = useState(false);
  const [erro,     setErro]     = useState("");
  const [sucesso,  setSucesso]  = useState(null);
  const [form, setForm] = useState({
    idContaOrigem:  "",
    idContaDestino: "",
    vlrTransferencia: "",
    dtTransacao: new Date().toISOString().split("T")[0],
    historico: "Transferência entre contas",
    observacao: "",
  });

  useEffect(() => {
    if (!idCondominio) return;
    contasBancariasService.listar(idCondominio)
      .then(r => setContas(r.data || []))
      .catch(() => {});
  }, [idCondominio]);

  const set = (f, v) => setForm(p => ({ ...p, [f]: v }));

  const contaOrigem  = contas.find(c => String(c.id) === String(form.idContaOrigem));
  const contaDestino = contas.find(c => String(c.id) === String(form.idContaDestino));

  const handleSubmit = async () => {
    setErro("");
    if (!form.idContaOrigem || !form.idContaDestino)
      return setErro("Selecione as contas de origem e destino.");
    if (form.idContaOrigem === form.idContaDestino)
      return setErro("Conta de origem e destino devem ser diferentes.");
    if (!form.vlrTransferencia || parseFloat(form.vlrTransferencia) <= 0)
      return setErro("Informe um valor válido.");
    if (!form.dtTransacao)
      return setErro("Informe a data da transferência.");

    setSaving(true);
    try {
      const r = await transacoesService.transferencia({
        ...form,
        idCondominio,
      });
      setSucesso(r);
      onSucesso && onSucesso(r);
    } catch(e) {
      setErro(e.message);
    }
    setSaving(false);
  };

  return (
    <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.5)"}}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-dialog modal-dialog-centered" style={{maxWidth:500}}
        onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header" style={{background:"#1B3A6B",color:"#fff"}}>
            <h5 className="modal-title">
              <i className="bi bi-arrow-left-right me-2"/>Transferência entre Contas
            </h5>
            <button className="btn-close btn-close-white" onClick={onClose}/>
          </div>

          <div className="modal-body">
            {sucesso ? (
              /* Tela de sucesso */
              <div style={{textAlign:"center",padding:"20px 0"}}>
                <div style={{fontSize:48,marginBottom:12}}>✅</div>
                <h5 style={{color:"#166534",fontWeight:700}}>{sucesso.message}</h5>
                <div style={{marginTop:20,display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                  {[
                    {label:"Conta Origem",  ...sucesso.saldos?.origem,  color:"#DC2626"},
                    {label:"Conta Destino", ...sucesso.saldos?.destino, color:"#166534"},
                  ].map((c,i) => (
                    <div key={i} style={{background:"var(--bg-surface-alt)",borderRadius:8,padding:"12px"}}>
                      <div style={{fontSize:11,color:"var(--gray-500)",fontWeight:600}}>{c.label}</div>
                      <div style={{fontWeight:700,fontSize:13,marginTop:4}}>{c.nmConta}</div>
                      <div style={{fontSize:12,marginTop:4}}>
                        Novo saldo: <span style={{fontWeight:700,color:c.color}}>{fmtM(c.saldoAtual)}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              /* Formulário */
              <div className="row g-3">
                {/* Conta Origem */}
                <div className="col-12">
                  <label className="form-label">Conta de Origem *</label>
                  <select className="form-select"
                    value={form.idContaOrigem}
                    onChange={e => set("idContaOrigem", e.target.value)}>
                    <option value="">— Selecione a conta —</option>
                    {contas.map(c => (
                      <option key={c.id} value={c.id}
                        disabled={String(c.id) === String(form.idContaDestino)}>
                        {c.nmConta} — {fmtM(c.saldoAtual)}
                      </option>
                    ))}
                  </select>
                  {contaOrigem && (
                    <small style={{color: parseFloat(contaOrigem.saldoAtual) < parseFloat(form.vlrTransferencia||0) ? "#DC2626" : "#166534"}}>
                      <i className="bi bi-wallet2 me-1"/>
                      Saldo disponível: <strong>{fmtM(contaOrigem.saldoAtual)}</strong>
                      {parseFloat(contaOrigem.saldoAtual) < parseFloat(form.vlrTransferencia||0) &&
                        <span style={{color:"#DC2626",marginLeft:8}}>⚠ Saldo insuficiente</span>}
                    </small>
                  )}
                </div>

                {/* Seta indicativa */}
                <div className="col-12" style={{textAlign:"center",padding:"0 8px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:12,color:"var(--gray-500)"}}>
                    <div style={{flex:1,height:1,background:"#E2E8F0"}}/>
                    <i className="bi bi-arrow-down-circle-fill" style={{fontSize:24,color:"#1B3A6B"}}/>
                    <div style={{flex:1,height:1,background:"#E2E8F0"}}/>
                  </div>
                </div>

                {/* Conta Destino */}
                <div className="col-12">
                  <label className="form-label">Conta de Destino *</label>
                  <select className="form-select"
                    value={form.idContaDestino}
                    onChange={e => set("idContaDestino", e.target.value)}>
                    <option value="">— Selecione a conta —</option>
                    {contas.map(c => (
                      <option key={c.id} value={c.id}
                        disabled={String(c.id) === String(form.idContaOrigem)}>
                        {c.nmConta} — {fmtM(c.saldoAtual)}
                      </option>
                    ))}
                  </select>
                  {contaDestino && (
                    <small style={{color:"var(--gray-500)"}}>
                      <i className="bi bi-wallet2 me-1"/>
                      Saldo atual: <strong>{fmtM(contaDestino.saldoAtual)}</strong>
                    </small>
                  )}
                </div>

                {/* Valor e Data */}
                <div className="col-md-6">
                  <label className="form-label">Valor *</label>
                  <div className="input-group">
                    <span className="input-group-text">R$</span>
                    <input type="number" step="0.01" min="0.01"
                      className="form-control" placeholder="0,00"
                      value={form.vlrTransferencia}
                      onChange={e => set("vlrTransferencia", e.target.value)}/>
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Data *</label>
                  <input type="date" className="form-control"
                    value={form.dtTransacao}
                    onChange={e => set("dtTransacao", e.target.value)}/>
                </div>

                {/* Histórico */}
                <div className="col-12">
                  <label className="form-label">Histórico</label>
                  <input type="text" className="form-control"
                    value={form.historico}
                    onChange={e => set("historico", e.target.value)}/>
                </div>

                {/* Observação */}
                <div className="col-12">
                  <label className="form-label">Observação (opcional)</label>
                  <textarea className="form-control" rows={2}
                    value={form.observacao}
                    onChange={e => set("observacao", e.target.value)}
                    placeholder="Motivo da transferência, referência, etc."/>
                </div>

                {/* Preview */}
                {form.idContaOrigem && form.idContaDestino && parseFloat(form.vlrTransferencia) > 0 && (
                  <div className="col-12">
                    <div style={{background:"var(--bg-highlight)",borderRadius:8,padding:"12px 16px",fontSize:13}}>
                      <div style={{fontWeight:700,color:"#1D4ED8",marginBottom:8}}>
                        <i className="bi bi-info-circle me-2"/>Resumo da Transferência
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between"}}>
                        <span style={{color:"var(--gray-500)"}}>De:</span>
                        <span style={{fontWeight:600}}>{contaOrigem?.nmConta}</span>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between"}}>
                        <span style={{color:"var(--gray-500)"}}>Para:</span>
                        <span style={{fontWeight:600}}>{contaDestino?.nmConta}</span>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between",marginTop:6,paddingTop:6,borderTop:"1px solid #BFDBFE"}}>
                        <span style={{color:"var(--gray-500)"}}>Valor:</span>
                        <span style={{fontWeight:800,fontSize:15,color:"#1D4ED8"}}>{fmtM(form.vlrTransferencia)}</span>
                      </div>
                    </div>
                  </div>
                )}

                {erro && (
                  <div className="col-12">
                    <div className="alert alert-danger py-2 mb-0">{erro}</div>
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="modal-footer">
            {sucesso ? (
              <button className="btn btn-primary" onClick={onClose}>
                <i className="bi bi-check2 me-2"/>Fechar
              </button>
            ) : (
              <>
                <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
                  {saving
                    ? <><span className="spinner-border spinner-border-sm me-2"/>Transferindo...</>
                    : <><i className="bi bi-arrow-left-right me-2"/>Confirmar Transferência</>}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
